import AxiosInterceptor from "api/interceptor";
import fx from "../../utils/fx";

const supplier = new AxiosInterceptor();

export default {
  find(id) {
    return supplier.get("/supplier/" + id);
  },
  get(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return supplier.get("/supplier?" + qstr);
  },
  delete(id) {
    return supplier.delete("/supplier/" + id);
  },
  create(inputs) {
    return supplier.post("/supplier", inputs);
  },
  update(id, inputs) {
    return supplier.put("/supplier/" + id, inputs);
  },
  searchSupplier(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return supplier.get("/supplier/search?" + qstr);
  }
};
